import { memo, useMemo } from 'react';

import { type Clip } from '@air/api/types';

import { FILE_PREVIEW_EXTENSION_MAP, FILE_PREVIEW_MAP } from '~/components/v2/constants/filePreview';
import { isValidFilePreviewExtension } from '~/components/v2/utils/files/isValidFilePreviewExtension';

export type AssetVersionThumbnailFileExtensionPreviewProps = {
  ext: Clip['ext'];
};

export const AssetVersionThumbnailFileExtensionPreview = memo(
  ({ ext }: AssetVersionThumbnailFileExtensionPreviewProps) => {
    const { color, icon: Icon } = useMemo(() => {
      if (isValidFilePreviewExtension(ext)) {
        return FILE_PREVIEW_EXTENSION_MAP[ext];
      }

      return FILE_PREVIEW_MAP.default;
    }, [ext]);

    const style = useMemo(() => {
      return {
        backgroundColor: color.backgroundColor,
        color: color.textColor,
      };
    }, [color]);

    return (
      <div className="flex size-full items-center justify-center" style={style}>
        <Icon className="size-6" />
      </div>
    );
  },
);

AssetVersionThumbnailFileExtensionPreview.displayName = 'AssetVersionThumbnailFileExtensionPreview';
